"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType["admin"] = "admin";
    UserType["superAdmin"] = "superadmin";
    UserType["collaborator"] = "collaborator";
    UserType["user"] = "user";
    UserType["management"] = "management";
    UserType["staff"] = "staff";
})(UserType || (exports.UserType = UserType = {}));
